import React, {useState} from 'react';
import ReactDatePicker from 'react-datepicker';
import {getDateFnsLocale, useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import clsx from 'clsx';
import {DatePickerBottomSheetData} from '@di-shared/features/history/download/DatePickerBottomSheet/index';
import useCldrDatetimeFormatter from '@di-shared/utils/useCldrDatetimeFormatter';

export default function () {
  const {selectedDate, minDate, maxDate} = (window as any).data as DatePickerBottomSheetData;
  const {t} = useInferableTranslation();
  const CldrDatetimeFormatter = useCldrDatetimeFormatter();
  const [innerDate, setInnerDate] = useState<Date>(selectedDate);

  return (
    <div className="bottom_sheet">
      <div className="bottom_sheet_header bottom_sheet_header_center">
        <h2 className="bottom_sheet_title">{t('T10168')}</h2>
        <button
          type="button"
          className="btn btn_ic"
          aria-label={t('T10017')}
          onClick={() => window.bottomSheetClose()}
        >
          <span
            className="ic ic_close_20px"
            aria-hidden="true"
          />
        </button>
      </div>
      <div className="bottom_sheet_inner">
        <div className="bottom_sheet_contents">
          <ReactDatePicker
            inline
            locale={getDateFnsLocale()}
            selected={innerDate}
            minDate={minDate}
            maxDate={maxDate}
            disabledKeyboardNavigation
            onChange={(date) => date && setInnerDate(date)}
            renderCustomHeader={({date, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled}) => (
              <div className="react-datepicker__current-month">
                <button
                  type="button"
                  aria-label="Previous Month"
                  className={clsx('react-datepicker__navigation react-datepicker__navigation--previous', {
                    'navigation--disabled': prevMonthButtonDisabled,
                  })}
                  disabled={prevMonthButtonDisabled}
                  onClick={() => decreaseMonth()}
                >
                  <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--previous">{t('T10100')}</span>
                </button>
                {CldrDatetimeFormatter.format(date, 'yMMM')}
                <button
                  type="button"
                  aria-label="Next Month"
                  className={clsx('react-datepicker__navigation react-datepicker__navigation--next', {
                    'navigation--disabled': nextMonthButtonDisabled,
                  })}
                  disabled={nextMonthButtonDisabled}
                  onClick={() => increaseMonth()}
                >
                  <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--next">{t('T10101')}</span>
                </button>
              </div>
            )}
          />
        </div>
        <div className="bottom_sheet_footer">
          <button
            type="button"
            className="btn btn_large btn_filled"
            onClick={() => (window as any).bottomSheetClose?.(innerDate)}
          >
            {t('T10169')}
          </button>
        </div>
      </div>
    </div>
  );
}
